export default {"src":"/_next/static/image/public/images/flags/flag_1684.81d6e2e0b5187470388b311a0516295f.svg","height":16,"width":24};